/* src/app/components/quantity-selector/quantity-selector.component.scss */
.quantity-selector {
  display: flex;
  font-size: calc(var(--quantity-selector-height) / 2);
}
.quantity-selector > * {
  border-top: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  border-bottom: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  background: var(--quantity-selector-background);
  line-height: var(--quantity-selector-height);
  padding: 0;
  text-align: center;
  font-weight: bold;
}
.quantity-selector > *:first-child {
  border-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  border-top-left-radius: 28px;
  border-bottom-left-radius: 28px;
}
.quantity-selector > *:last-child {
  border-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;
  border-top-right-radius: 28px;
  border-bottom-right-radius: 28px;
}
.square {
  width: var(--quantity-selector-height);
  height: var(--quantity-selector-height);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rectangle {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(1 * var(--quantity-selector-height));
  height: var(--quantity-selector-height);
}
/*# sourceMappingURL=quantity-selector.component.css.map */
